import { Quote, Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Maria D.",
    town: "Massapequa, NY",
    text: "Vasquez & Son re-sided our whole house in a week and it looks unbelievable. Crew was respectful, on time and detail-oriented. Best contractor we've hired.",
    service: "Siding",
  },
  {
    name: "Robert P.",
    town: "Hicksville, NY",
    text: "New roof after a rough winter. They walked me through options, gave a fair quote and finished ahead of schedule. Cleaned up like they were never here.",
    service: "Roofing",
  },
  {
    name: "Jennifer L.",
    town: "Freeport, NY",
    text: "Kitchen and bathroom remodel — floor to ceiling. The tile work is spotless. I get compliments every time I have people over. Highly recommend.",
    service: "Kitchen & Baths",
  },
];

export default function Testimonials() {
  return (
    <section className="relative bg-white text-black py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="mb-14 md:mb-20 grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[color:var(--vs-blue)]" />
              <span className="font-mono-accent text-xs tracking-[0.3em] uppercase text-[color:var(--vs-blue)]">
                004 / Neighbors say
              </span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl font-bold leading-[0.95] tracking-tight text-black">
              Trusted by <br />
              <span className="text-[color:var(--vs-blue)]">Long Island</span>{" "}
              families.
            </h2>
          </div>
          <div className="lg:col-span-4 text-gray-600 text-base leading-relaxed">
            Word of mouth is how we&apos;ve grown. Here&apos;s what a few of our neighbors
            have to say.
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              className="relative border border-black/10 p-8 md:p-10 flex flex-col min-h-[320px] hover:border-[color:var(--vs-blue)] transition-colors"
            >
              <Quote className="w-9 h-9 text-[color:var(--vs-blue)] mb-6" strokeWidth={1.5} />
              <p className="text-lg leading-relaxed text-black/85">&ldquo;{r.text}&rdquo;</p>
              <div className="mt-auto pt-6 border-t border-black/10 flex items-center justify-between">
                <div>
                  <div className="font-display uppercase tracking-tight text-black font-semibold">
                    {r.name}
                  </div>
                  <div className="font-mono-accent text-[11px] tracking-[0.25em] uppercase text-gray-500 mt-1">
                    {r.town} · {r.service}
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star
                      key={k}
                      className="w-4 h-4 fill-[color:var(--vs-blue)] text-[color:var(--vs-blue)]"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
